module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Fermer","flags":["TRACK"],"track":"Close"}}